import "./AppLoader.styl";

import React from "react";
import { connect } from "react-redux";

import { Progress } from "reactstrap";

class AppLoader extends React.Component {
  constructor() {
    super();
  }

  render() {
    const { appLoading } = this.props;

    return (
      <div>
        {appLoading > 0 &&
          <Progress className="app-loading" animated value="100" />}
      </div>
    );
  }
}

export default connect(
  state => ({
    appLoading: state.app.appLoading
  }),
  {}
)(AppLoader);



/** WEBPACK FOOTER **
 ** ./src/browser/components/AppLoader/AppLoader.js
 **/